import { Tag } from 'antd';
import { trangThaiLopDaoTao } from '../../constants';

const trangThaiTagMap: Record<number, { color: string; label: string }> = {
    [trangThaiLopDaoTao.chuaKhoiTao]: { color: "default", label: "Chưa khởi tạo" },
    [trangThaiLopDaoTao.khoiTao]: { color: "processing", label: "Khởi tạo" },
    [trangThaiLopDaoTao.thuHoi]: { color: "warning", label: "Thu hồi" },
    [trangThaiLopDaoTao.trinhPhoCVP]: { color: "purple", label: "Trình phó chánh văn phòng" },
    [trangThaiLopDaoTao.phoCVPTraLai]: { color: "error", label: "Phó chánh văn phòng từ chối" },
    [trangThaiLopDaoTao.trinhCVP]: { color: "cyan", label: "Trình chánh văn phòng" },
    [trangThaiLopDaoTao.chanhVPTraLai]: { color: "error", label: "Chánh văn phòng từ chối" },
    [trangThaiLopDaoTao.trinhPhoGiamDoc]: { color: "blue", label: "Trình Phó Giám đốc" },
    [trangThaiLopDaoTao.phoGiamDocTraLai]: { color: "error", label: "Phó Giám đốc từ chối" },
    [trangThaiLopDaoTao.trinhGiamDoc]: { color: "gold", label: "Trình lãnh đạo đơn vị" },
    [trangThaiLopDaoTao.giamDocTraLai]: { color: "error", label: "Lãnh đạo đơn vị từ chối" },
    [trangThaiLopDaoTao.pheDuyet]: { color: "success", label: "Duyệt" },
    [trangThaiLopDaoTao.hoanThanh]: { color: "green", label: "Hoàn thành" },
};

const TrangThaiLopDaoTaoTag = ({ value }: { value?: number }) => {
    if (value === undefined || value === null) return null;

    const config = trangThaiTagMap[value];

    if (!config) return <span></span>;

    return <Tag color={config.color}>{config.label}</Tag>;
};

export default TrangThaiLopDaoTaoTag;
